import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Returns a click handler (for `onClickCapture` on a wrapper) that routes same-origin
 * `<a href>` clicks through the router, for components that render plain anchors.
 */
export default function useSpaLinkClick(onNavigate?: (pathname: string) => void) {
  const navigate = useNavigate();

  return useCallback(
    (event: React.MouseEvent<HTMLElement>) => {
      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
        return;
      }

      const anchor = (event.target as HTMLElement | null)?.closest('a');
      if (!anchor || anchor.target === '_blank' || anchor.hasAttribute('download')) return;

      const href = anchor.getAttribute('href');
      if (!href || href.startsWith('#')) return;

      const url = new URL(href, window.location.href);
      if (url.origin !== window.location.origin) return;

      event.preventDefault();
      navigate(url.pathname + url.search + url.hash);
      onNavigate?.(url.pathname);
    },
    [navigate, onNavigate],
  );
}
